const regexps = {
  email: /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,4}$/,
  postalCode: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z][0-9][A-Z][0-9]$/,
  price: /(\d)(?=(\d\d\d)+(?!\d))/g,
  sqft: /\B(?=(\d{3})+(?!\d))/g,
  startsWithNumber: /^\d/,
  name: /[!@#$%^&*()+{}[]?!<>"\\]/g,
  alphaNumeric: /[^a-zA-Z0-9]/g,
  thousandsSeperator: /(\d)(?=(\d\d\d)+(?!\d))/g,
};

export default regexps;
